class WSteps extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.list = this.querySelector('.w-steps__list');
    this.rail = this.querySelector('.w-steps__rail');
    this.fill = this.querySelector('.w-steps__rail-fill');
    this.items = Array.from(this.querySelectorAll('.w-steps__item'));
    this.dots = this.items.map((item) => item.querySelector('.w-steps__dot'));
    if (!this.list || this.items.length === 0) return;

    const { signal } = this.controller;
    this.ticking = false;
    window.addEventListener('scroll', () => this.onScroll(), { passive: true, signal });
    window.addEventListener('resize', () => this.update(), { signal });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        if (!signal.aborted) this.update();
      });
    }

    this.update();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.ticking = false;
      this.update();
    });
  }

  update() {
    const listTop = this.list.getBoundingClientRect().top;
    const firstDot = this.dots[0].getBoundingClientRect();
    const lastDot = this.dots[this.dots.length - 1].getBoundingClientRect();
    const railTop = firstDot.top + firstDot.height / 2;
    const railHeight = lastDot.top + lastDot.height / 2 - railTop;

    if (this.rail) {
      this.rail.style.top = railTop - listTop + 'px';
      this.rail.style.height = railHeight + 'px';
    }

    const trigger = window.innerHeight * 0.6;
    if (this.fill) {
      this.fill.style.height = Math.max(0, Math.min(trigger - railTop, railHeight)) + 'px';
    }

    this.items.forEach((item, index) => {
      const dot = this.dots[index].getBoundingClientRect();
      item.classList.toggle('is-active', dot.top + dot.height / 2 <= trigger);
    });
  }
}

customElements.define('w-steps', WSteps);
